/* jokers-size-card.js — 181026 (181026: header rewritten to describe the card as it works today.
   History: 101026 arm-once scheduling; 111026 per-costume skip, emptied-cart clean-up, grid row;
   121026 dark cards; 13 Oct "I know my size" button removed; 181026 code-review fixes.)

   Size Fit status in the CART DRAWER + two product-page nudges. Loaded once from
   snippets/jokers-scan-reminder.liquid (rendered in the cart drawer on every page).
   Nothing here blocks an add or a checkout.

   CART DRAWER — one small card under each ADULT costume line (product type contains "men", or an adult
   "Costumes - Unisex" — see isCostume; same test as the checkout popup), spanning the full width of the line (grid: photo | details | qty):
     _jk_size_scan = recommended               → green "Size Fit Guarantee activated"
     _jk_size_scan = ignored, line = scan rec  → green "Your recommended size"
     _jk_size_scan = ignored, rec differs      → amber "Your scan recommends X" + Swap to X (when X is made + in stock)
     _jk_size_scan = ignored, rec unknown      → amber "Choose your recommended size to get the Size Fit Guarantee"
     _jk_size_scan = nomatch / mismatch        → grey  "Size Fit Guarantee not available for this costume"
     no stamp, device HAS a scan               → judged from the product page's cached result (jk_ms:<product id>):
                                                 match → green, differs → amber + Swap, unknown → nothing
                                                 (the checkout size check handles it)
     no stamp, no scan, not skipped            → "Get the Size Fit Guarantee on M. Check your size in 2 minutes…" + Check my size
     no stamp, no scan, skipped at checkout    → grey "Size Fit Guarantee not activated · Check my size"
       (a skip covers only the costumes it was given for: cart attribute _jk_skip_items = product ids,
        written by the checkout popup)
   "Check my size": anywhere else → that costume's product page (#jk-scan), which scrolls to the size
     tool and opens the scan there. Already on that costume's page → the drawer closes and the scan
     opens right there (waits up to ~4s for the size tool to be ready). A device that already has a
     scan is never sent to a scan start screen and never starts a new scan — it is only brought to
     the size area.
   "Swap to X": adds the recommended variant (copies the line's delivery properties, stamps it
     recommended), then removes the old line (retried, then removed by key from a fresh /cart.js),
     holding window.JokersCart so jokers-cart.js stands down while it runs.
   An emptied cart drops the skip record and the old delivery choice (Shopify keeps cart attributes
   after the last item goes), so the next costume starts clean.

   PRODUCT PAGE (only when sizer-block's amber "You've selected M — your recommended size is XL"
   card is showing):
     - its "Switch to XL" link is styled as a proper green button
     - a one-line reminder under Add to cart: "[Switch to X-Large] to get the Size Fit Guarantee." */
(function () {
  if (window.__jkSizeCard) return;
  window.__jkSizeCard = true;

  /* ---------------- shared helpers ---------------- */
  /* 181026: was '__jk_skip_items'. Shopify keeps "__" cart attributes private (cart.js never returns them),
     so a skip could never be read back and customers were asked again. One underscore = hidden at
     checkout but readable here. The old name is still cleared. */
  var SKIP_ITEMS = '_jk_skip_items';     // product ids the skip was given for (shared with the checkout popup)
  var SIZE_ATTRS = ['Size Scan', 'Size Scan Reason', 'Size Scan Tried On', 'Size Scan Problem', 'Size Scan Details',
                    'Size Scan Record', 'Size Scan Device', 'Size Scan Acknowledged', 'Size Scan Check',
                    'Size Scan Skipped At', 'Size Scan Last Session', SKIP_ITEMS, '__jk_skip_items'];
  function skipList(c) {
    var a = (c && c.attributes) || {};
    if (String(a['Size Scan'] || '') !== 'Ignored' || !a['Size Scan Reason']) return [];
    return String(a[SKIP_ITEMS] || '').split(',').filter(Boolean);
  }
  /* 181026: the drawer no longer sets this flag ("I know my size" removed 13 Oct) — it only clears it */
  function clearSkipDevice() { try { localStorage.removeItem('jk_skip_set'); } catch (e) {} }
  function skipDeviceSet() { try { return !!localStorage.getItem('jk_skip_set'); } catch (e) { return false; } }
  function hasScan() { try { return !!localStorage.getItem('ms_access_code2'); } catch (e) { return false; } }
  function cachedScan(pid) {
    try { var c = localStorage.getItem('jk_ms:' + pid); return c ? JSON.parse(c) : null; } catch (e) { return null; }
  }
  /* 181026: ADULT Costumes - Unisex counts too (same rule as the checkout popup and sizer-block): the title says
     "adult", or nothing in the title or size points to a child (that type also holds toddler/baby/kids costumes) */
  function isCostume(it) {
    var t = String(it.product_type || '').toLowerCase();
    if (t.indexOf('men') !== -1) return true;
    if (t.indexOf('unisex') === -1) return false;
    var pt = String(it.product_title || '');
    if (/\badult\b/i.test(pt)) return true;
    return !/\b(child|children|kids?|toddler|infant|baby|teen|youth|junior)\b|\b(years?|yrs|months?)\b|\bage\s*\d/i.test(pt + ' ' + String(it.variant_title || ''));
  }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function szNorm(v) {
    v = String(v || '').toLowerCase().replace(/size/g, '').replace(/[^a-z0-9]/g, '')
      /* "Double Extra Large" / "Extra Extra Large" / "Triple Extra Large" -> xxl / xxl / xxxl */
      .replace(/^(double|two|extraextra)extra/, 'xx').replace(/^extraextra/, 'xx').replace(/^(triple|three)extra/, 'xxx');
    var m = { extrasmall: 'xs', xsmall: 'xs', small: 's', medium: 'm', large: 'l',
              extralarge: 'xl', xlarge: 'xl', xxlarge: 'xxl', '2xl': 'xxl', '2xlarge': 'xxl',
              xxxlarge: 'xxxl', '3xl': 'xxxl', '3xlarge': 'xxxl', '4xl': 'xxxxl', xxxxlarge: 'xxxxl' };
    var r = m[v] || v, p = /^plus(.+)$/.exec(r);
    /* brand sizes like "Plus Xxl" / "Plus XL" are that letter size; a plain "Plus" stays "plus" */
    if (p) { var q = m[p[1]] || p[1]; if (/^(x*s|m|x*l)$/.test(q)) r = q; }
    return r;
  }
  /* 181026: size matching lives in snippets/jokers-size-core.liquid (JokersSize). The old copy here
     missed "X-Large 16-18" style names and matched "S/M" as Small. The lines below are a fallback only. */
  function szKey(v) {
    if (window.JokersSize) return window.JokersSize.key(v);
    v = String(v || '');
    var head = v.split(/\s+-\s+|\s*\(/)[0];
    var word = head.match(/^\s*(extra\s*small|extra\s*large|x*s|x*l|\dxl|small|medium|large|m)\b/i);
    if (word) return szNorm(word[1]);
    return szNorm(head);
  }
  function shortSize(v) { if (window.JokersSize) return window.JokersSize.short(v); return String(v || '').split(/\s+-\s+|\s*\(/)[0].trim(); }
  function prettySize(v) {
    var n = { xs: 'Extra Small', s: 'Small', m: 'Medium', l: 'Large', xl: 'Extra Large', xxl: 'XXL', xxxl: 'XXXL' }[szKey(v)];
    return n || String(v || '');
  }
  function lineSize(it) {
    var o = (it.options_with_values || []).filter(function (x) { return /size/i.test(x.name || ''); })[0];
    if (o) return o.value;
    return (it.variant_options && it.variant_options[0]) || it.variant_title || '';
  }
  function isOneSize(sz) { return !sz || /^(one\s*size|os|standard|free\s*size|default title)/i.test(String(sz).trim()); }
  function stampNow() {
    try {
      return new Date().toLocaleString('en-AU', { timeZone: 'Australia/Brisbane', day: '2-digit', month: '2-digit', year: 'numeric', hour: 'numeric', minute: '2-digit' }) + ' (Brisbane)';
    } catch (e) { return new Date().toString(); }
  }
  /* 181026: deviceInfo() removed — only the removed "I know my size" skip used it */

  /* cart writes wait for jokers-cart.js to be idle, and hold .removing so it stands down */
  function jk() { return (window.JokersCart = window.JokersCart || { writes: 0, removing: false }); }
  function whenIdle() {
    return new Promise(function (res) {
      (function w(n) { var J = jk(); if ((!J.writes && !J.removing) || n > 160) { res(); return; } setTimeout(function () { w(n + 1); }, 50); })(0);
    });
  }
  function lock(fn) {
    return whenIdle().then(function () {
      jk().removing = true;
      var done = function () { jk().removing = false; };
      return Promise.resolve().then(fn).then(function (v) { done(); return v; }, function (e) { done(); throw e; });
    });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });   // 181026: check r.ok
  }

  /* ---------------- styles ---------------- */
  var css = [
    '.jk-sc{margin:6px 0 0;padding:6px 10px;border-radius:8px;font-size:12.5px;line-height:1.35;text-align:left;border:1px solid transparent;}',
    /* full width of the cart line: the line wraps and the card takes its own row under photo + details */
    'li[id^="CartDrawer-Item-"].jk-sc-host{display:grid !important;grid-template-columns:auto minmax(0,1fr) auto;align-items:start;row-gap:8px !important;}',
    'li[id^="CartDrawer-Item-"].jk-sc-host:not(:has(> .horizontal-product__media)){grid-template-columns:minmax(0,1fr) auto;}',
    'li[id^="CartDrawer-Item-"] > .jk-sc{grid-column:1 / -1;width:100%;max-width:100%;box-sizing:border-box;margin:0 0 4px;padding:6px 10px 7px;font-size:12px;line-height:1.3;border-radius:6px;}',
    '#CartDrawer cart-items{padding-bottom:10px;}',
    '.jk-sc a.jk-sc__lnk{color:inherit;font-weight:700;text-decoration:underline;text-underline-offset:2px;}',
    '.jk-sc p{margin:0 !important;padding:0 !important;}',
    '.jk-sc b{font-weight:800;}',
    '.jk-sc__acts{margin-top:3px !important;display:flex;flex-wrap:wrap;align-items:center;gap:2px 10px;}',
    /* 181026: was a reset + underline for every card button (for the removed "I know my size" link-button).
       Only the Swap button is left; it keeps the reset so theme button styles don't leak in. */
    '.jk-sc button.jk-sc__go{all:unset;box-sizing:border-box;cursor:pointer;font:inherit;}',
    '.jk-sc .jk-sc__btn,.jk-sc button.jk-sc__go{display:inline-flex !important;align-items:center;padding:3px 11px !important;border-radius:999px !important;background:#1f9d55 !important;color:#fff !important;font-size:12px !important;font-weight:800 !important;line-height:1.2 !important;text-decoration:none !important;white-space:nowrap;}',
    '.jk-sc .jk-sc__btn:hover,.jk-sc button.jk-sc__go:hover{background:#17844a !important;}',
    '.jk-sc p.jk-sc__head{display:flex;align-items:flex-start;gap:6px;}',
    '.jk-sc__ico{flex:0 0 auto;width:15px;height:15px;margin-top:1px;color:#F49F11;}',
    '.jk-sc p.jk-sc__acts--ask{margin-top:5px !important;padding-left:21px !important;gap:4px 14px;}',
    '.jk-sc button[disabled]{opacity:.55;cursor:default;}',
    /* 181026: Swap shows it is working straight away (it can take a few seconds while the cart updates) */
    '.jk-sc button.jk-sc__go.is-busy{opacity:1 !important;background:#17844a !important;}',
    '.jk-sc__spin{display:inline-block;flex:0 0 auto;width:11px;height:11px;margin-right:7px;border:2px solid rgba(255,255,255,.45);border-top-color:#fff;border-radius:50%;animation:jkscspin .7s linear infinite;}',
    '@keyframes jkscspin{to{transform:rotate(360deg)}}',
    /* 121026 j: dark cards that match the navy drawer, with a coloured left edge per state */
    '.jk-sc--ask,.jk-sc--ok,.jk-sc--off,.jk-sc--na{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);border-left:3px solid rgba(255,255,255,.35);color:#fff;}',
    '.jk-sc--ask{border-left-color:#F49F11;}',
    '.jk-sc--ok{border-left-color:#3fbf74;color:#bff0d2;}',
    '.jk-sc--off{border-left-color:#F49F11;color:#ffd99a;}',
    '.jk-sc--na{color:rgba(255,255,255,.72);}',
    '.jk-sc__err{margin-top:4px !important;font-weight:700;color:#ff8f80;}',
    /* product page: the amber card's "Switch to XL" as a real button */
    '.jk-sz--recommended.jk-sz--off .jk-sz__card-links a[data-jk-switch],',
    '.rte .jk-sz--recommended.jk-sz--off .jk-sz__card-links a[data-jk-switch]{display:inline-flex !important;align-items:center;justify-content:center;padding:8px 14px !important;border-radius:8px !important;background:#1f8a4c !important;background-image:none !important;color:#fff !important;font-size:13px !important;font-weight:800 !important;text-decoration:none !important;white-space:nowrap;}',
    '.jk-sz--recommended.jk-sz--off .jk-sz__card-links a[data-jk-switch]:hover{background:#17752f !important;}',
    /* product page: reminder under Add to cart */
    '.jk-atc-note{margin:10px 0 0 !important;padding:9px 12px;border-radius:8px;background:#fff8e6;border:1px solid #f2d791;color:#6b4a00;font-size:13.5px;line-height:1.4;}',
    '.jk-atc-note[hidden]{display:none !important;}',
    /* 181026: the Switch button now leads the reminder line */
    '.jk-atc-note button{background:none;border:0;padding:0;margin:0;font:inherit;font-weight:800;color:#6b4a00;text-decoration:underline;cursor:pointer;}'
  ].join('\n');
  var st = document.createElement('style');
  st.id = 'jk-size-card-css';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  /* =====================================================================
     CART DRAWER
     ===================================================================== */
  var drawer = null;
  var cart = null;             // last /cart.js
  var sig = '';                // drawer line ids last time we fetched
  var fetching = false, refetch = false;
  var timer = null;
  var busyLines = {};          // line key → action running (swap) / 'done' until the drawer re-renders   181026
  var busyName = {};           // line key → the size being swapped to (for "Swapping to X…")
  var errors = {};             // line key → message

  function drawerLines() {
    return drawer ? Array.prototype.slice.call(drawer.querySelectorAll('li[id^="CartDrawer-Item-"]')) : [];
  }
  function itemFor(li, items, i) {
    var key = li.id.replace('CartDrawer-Item-', '');
    var it = items.filter(function (x) { return x.key === key; })[0];
    if (it) return it;
    var vid = li.getAttribute('data-variant-id');
    var same = items.filter(function (x) { return String(x.variant_id || x.id) === String(vid); });
    if (same.length === 1) return same[0];
    return items[i] && String(items[i].variant_id || items[i].id) === String(vid) ? items[i] : null;
  }
  /* 111026: answered only for the costumes the skip was given for */
  function answered(c, it) {
    return !!it && skipList(c).indexOf(String(it.product_id)) !== -1;
  }
  function scanUrl(it) {
    var u = String((it && it.url) || ('/products/' + ((it && it.handle) || ''))).split('#')[0];
    return u + '#jk-scan';
  }
  /* 181026: the costume's OWN name for the recommended size (e.g. "X-Large", not Mirrorsize's
     "Extra Large") and whether that size is made / in stock (avail 'ok' | 'soldout' | 'unmade';
     null while unknown), from /products/<handle>.js. Until it arrives the card shows the generic
     name and no Swap button, then repaints. A failed lookup is NOT cached: it is retried on a later
     paint (at most every 5s). Good product JSON is kept (products{}) so Swap reuses it. */
  var labels = {}, labelFailedAt = {};
  var products = {}, productsInFlight = {};
  function getProduct(handle) {
    if (products[handle]) return Promise.resolve(products[handle]);
    if (productsInFlight[handle]) return productsInFlight[handle];
    var p = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
      .then(function (j) { products[handle] = j; return j; });
    productsInFlight[handle] = p;
    var clear = function () { delete productsInFlight[handle]; };
    p.then(clear, clear);
    return p;
  }
  function recInfo(it, rec) {
    var k = it.handle + '|' + szKey(rec), generic = { name: prettySize(rec), avail: null };
    if (Object.prototype.hasOwnProperty.call(labels, k)) return labels[k] || generic;
    if (labelFailedAt[k] && Date.now() - labelFailedAt[k] < 5000) return generic;
    labels[k] = null;   // lookup in flight
    variantFor(it, rec).then(function (f) {
      delete labelFailedAt[k];
      labels[k] = f ? { name: shortSize(f.label), avail: f.v.available ? 'ok' : 'soldout' } : { name: prettySize(rec), avail: 'unmade' };
      paint();
    }).catch(function (e) {
      delete labels[k]; labelFailedAt[k] = Date.now();   // 181026: not cached — retried later
      try { console.warn('[jk-size-card] product lookup failed', it.handle, e); } catch (x) {}
    });
    return generic;
  }
  function recLabel(it, rec) { return recInfo(it, rec).name; }
  function recFor(it) {
    var c = cachedScan(it.product_id);
    return c && c.state === 'recommended' && c.size ? c.size : null;
  }

  var ICON_TAPE = '<svg class="jk-sc__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"/><path d="m14.5 12.5 2-2"/><path d="m11.5 9.5 2-2"/><path d="m8.5 6.5 2-2"/><path d="m17.5 15.5 2-2"/></svg>';

  /* What the card for this line should say → {cls, html} or null for no card. */
  function cardFor(it, c) {
    var v = String((it.properties || {})._jk_size_scan || '').toLowerCase();
    var sz = lineSize(it), szS = shortSize(sz);
    var guaranteeOn = '<p><b>&#10003; Size Fit Guarantee activated</b></p>';
    function offCard(rec) {
      var ri = recInfo(it, rec), name = ri.name;
      /* 121026 n: same icon as the "isn't covered yet" card.
         181026: positive wording — the guarantee is something they GET by switching (keys bumped so cards repaint) */
      function head(t) { return '<p class="jk-sc__head">' + ICON_TAPE + '<span>' + t + '</span></p>'; }
      var recB = '<b>Your scan recommends ' + esc(name) + '.</b> ';
      if (ri.avail === 'unmade') return { cls: 'jk-sc--off', key: 'unmade3:' + rec + ':' + name,
        html: head(recB + 'Choose a costume that comes in ' + esc(name) + ' to get the Size Fit Guarantee.') };
      return { cls: 'jk-sc--off', key: 'off3:' + rec + ':' + name + ':' + ri.avail,
        html: head(recB +
                   (ri.avail === 'ok' ? 'Swap to get the Size Fit Guarantee.'
                    : ri.avail === 'soldout' ? 'It&rsquo;s sold out in this costume &mdash; choose another costume in ' + esc(name) + ' to get the Size Fit Guarantee.'
                    : 'Choose ' + esc(name) + ' to get the Size Fit Guarantee.')) +
              (ri.avail === 'ok' ? '<p class="jk-sc__acts jk-sc__acts--ask"><button type="button" class="jk-sc__go" data-jk-sc="swap" data-rec="' + esc(rec) + '">Swap to ' + esc(name) + '</button></p>' : '') };
    }
    if (v === 'recommended') return { cls: 'jk-sc--ok', key: 'ok', html: guaranteeOn };
    if (v === 'ignored') {
      var r = recFor(it);
      /* 181026: a skipped line that IS the recommended size gets the green card (was always amber) */
      if (r && szKey(r) === szKey(sz)) return { cls: 'jk-sc--ok', key: 'ok2', html: '<p><b>&#10003; Your recommended size</b></p>' };
      if (r) return offCard(r);
      return { cls: 'jk-sc--off', key: 'off3', html: '<p class="jk-sc__head">' + ICON_TAPE + '<span><b>Choose your recommended size</b> to get the Size Fit Guarantee.</span></p>' };
    }
    if (v === 'nomatch' || v === 'mismatch') {
      return { cls: 'jk-sc--na', key: 'na', html: '<p>Size Fit Guarantee not available for this costume.</p>' };
    }
    if (v) return null;
    if (hasScan()) {
      var cs = cachedScan(it.product_id);
      if (cs && cs.state === 'recommended' && cs.size) {
        if (szKey(cs.size) === szKey(sz)) return { cls: 'jk-sc--ok', key: 'ok2', html: '<p><b>&#10003; Your recommended size</b></p>' };
        return offCard(cs.size);
      }
      if (cs && (cs.state === 'nomatch' || cs.state === 'mismatch')) {
        return { cls: 'jk-sc--na', key: 'na', html: '<p>Size Fit Guarantee not available for this costume.</p>' };
      }
      return null;   // unknown → the checkout size check asks Mirrorsize
    }
    var link = '<a class="jk-sc__lnk" data-jk-sc="scan" href="' + esc(scanUrl(it)) + '">';
    if (answered(c, it)) {
      return { cls: 'jk-sc--na', key: 'skipped',
        html: '<p>Size Fit Guarantee not activated &middot; ' + link + 'Check my size</a></p>' };
    }
    /* 181026: positive wording — what they GET by checking (was "M isn't covered yet") */
    var q = isOneSize(sz) ? 'Get the Size Fit Guarantee on this costume.' : 'Get the Size Fit Guarantee on ' + esc(szS) + '.';
    return { cls: 'jk-sc--ask', key: 'ask6',
      html: '<p class="jk-sc__head">' + ICON_TAPE + '<span><b>' + q + '</b> Check your size in 2 minutes &mdash; free exchange if it doesn&rsquo;t fit.</span></p>' +
            '<p class="jk-sc__acts jk-sc__acts--ask"><a class="jk-sc__btn" data-jk-sc="scan" href="' + esc(scanUrl(it)) + '">Check my size</a>' +
            '</p>' };
  }

  /* 181026: paint() requests are folded into one per animation frame (the drawer mutates constantly) */
  var paintQueued = false;
  function paint() {
    if (paintQueued) return;
    paintQueued = true;
    var run = function () { paintQueued = false; paintNow(); };
    if (window.requestAnimationFrame && !document.hidden) requestAnimationFrame(run); else setTimeout(run, 16);
  }
  function paintNow() {
    if (!cart) return;
    var items = cart.items || [];
    drawerLines().forEach(function (li, i) {
      var it = itemFor(li, items, i);
      var card = it && isCostume(it) ? cardFor(it, cart) : null;
      var el = li.querySelector('.jk-sc');
      if (!card) { if (el) el.parentNode.removeChild(el); li.classList.remove('jk-sc-host'); return; }
      var k = it.key, err = errors[k];
      /* 181026: swap finished — say so until the drawer swaps the line over */
      if (busyLines[k] === 'done') card = { cls: 'jk-sc--ok', key: 'swapped', html: '<p><b>&#10003; Swapped to ' + esc(busyName[k] || 'your recommended size') + '</b> &mdash; updating your cart&hellip;</p>' };
      var want = card.cls + '|' + card.key + '|' + (busyLines[k] || '') + '|' + (err || '');
      if (el && el.getAttribute('data-jk-want') === want) return;    // already right — no DOM churn
      if (el && el.parentNode !== li) { el.parentNode.removeChild(el); el = null; }   // an older in-details card
      if (!el) {
        el = document.createElement('div');
        li.classList.add('jk-sc-host');
        li.appendChild(el);
      }
      el.className = 'jk-sc ' + card.cls;
      el.setAttribute('data-jk-want', want);
      el.setAttribute('data-jk-key', k);
      el.innerHTML = card.html + (err ? '<p class="jk-sc__err">' + esc(err) + '</p>' : '');
      if (busyLines[k]) Array.prototype.forEach.call(el.querySelectorAll('button'), function (b) {
        b.disabled = true;
        if (busyLines[k] === 'swap' && b.getAttribute('data-jk-sc') === 'swap') {
          b.classList.add('is-busy');
          b.innerHTML = '<span class="jk-sc__spin" aria-hidden="true"></span>Swapping to ' + esc(busyName[k] || '') + '&hellip;';
        }
      });
    });
  }

  /* 111026: an emptied cart keeps its attributes in Shopify — drop the skip record and the old
     delivery choice so the next costume starts clean (size question asked, Standard default).
     Runs when this page sees the last line go, or on load with an empty drawer on a device that
     had a cart (localStorage jk_cart_had) — no extra request for anyone else. */
  var DELIVERY_ATTR = /^(type of order$|pick.?up|delivery (date|day|time)$|locationid$)/i;
  var hadLines = false, emptyChecked = false;
  function cartHadSet(on) { try { if (on) localStorage.setItem('jk_cart_had', '1'); else localStorage.removeItem('jk_cart_had'); } catch (e) {} }
  function cartHad() { try { return !!localStorage.getItem('jk_cart_had'); } catch (e) { return false; } }
  /* 181026: runs under the same lock() as Swap (jokers-cart.js stands down) and logs failures */
  function clearIfEmpty(force) {
    if (!force && !skipDeviceSet() && !cartHad()) return;
    lock(function () {
      return getCart().then(function (c) {
        if (!c || (c.items && c.items.length)) return;
        var a = c.attributes || {}, w = {}, n = 0;
        Object.keys(a).forEach(function (k) {
          if (a[k] && (SIZE_ATTRS.indexOf(k) !== -1 || DELIVERY_ATTR.test(k))) { w[k] = ''; n++; }
        });
        var tidy = function () { clearSkipDevice(); cartHadSet(false); };
        if (!n) { tidy(); return; }
        return post('/cart/update.js', { attributes: w }).then(function (c2) { tidy(); if (c2) cart = c2; });
      });
    }).catch(function (e) { try { console.warn('[jk-size-card] could not tidy the emptied cart', e); } catch (x) {} });
  }

  var waitSince = 0;
  function refresh(force) {
    if (!drawer) return;
    var lines = drawerLines();
    if (!lines.length) { if (hadLines || !emptyChecked) { var f = hadLines; hadLines = false; emptyChecked = true; clearIfEmpty(f); } return; }
    if (!hadLines) cartHadSet(true);
    hadLines = true;
    var s = lines.map(function (li) { return li.id + ':' + li.getAttribute('data-quantity'); }).join(',');
    if (!force && s === sig && cart) { paint(); return; }
    /* 121026 k: put the cards straight back from the last cart we have (a quantity change keeps the
       line key, so the card is still right), then refresh the details in the background. Before this
       the card stayed missing until jokers-cart.js and ShipZip finished writing - several seconds. */
    if (cart) paint();
    if (fetching) { refetch = true; return; }
    /* let jokers-cart.js finish a write first — but never wait more than 4s */
    if ((jk().removing || jk().writes) && (!waitSince || Date.now() - waitSince < 4000)) {
      if (!waitSince) waitSince = Date.now();
      schedule(400, force); return;
    }
    waitSince = 0;
    fetching = true;
    getCart().then(function (c) {
      cart = c; sig = s;
    }).catch(function () {}).then(function () {
      fetching = false;
      paint();
      if (refetch) { refetch = false; refresh(true); }
    });
  }
  /* Arm ONCE — never reset. The drawer mutates constantly (delivery widget, timers), and a
     resettable debounce was starved by that churn, so the cards never painted on the live page. */
  var forceNext = false;
  function schedule(ms, force) {
    if (force) forceNext = true;
    if (timer) return;
    timer = setTimeout(function () { timer = null; var f = forceNext; forceNext = false; refresh(f); }, ms || 250);
  }

  /* ---- actions ---- */
  function closeDrawer() {
    var d = document.getElementById('CartDrawer');
    try { if (d && typeof d.hide === 'function') { d.hide(); return; } } catch (e) {}
    var ov = d && d.querySelector('overlay-element, [aria-controls="CartDrawer"]');
    if (ov) ov.click();
  }
  function onThisProduct(it) {
    var sgb = document.getElementById('jokers-sgb');
    return !!(it && sgb && String(sgb.getAttribute('data-jk-product-id')) === String(it.product_id));
  }
  /* 111026: the scan runs on the costume's own product page.
     181026: on that page a not-yet-ready #generateBtn is waited for (up to ~4s, like scanOnArrival)
     instead of sending the customer to /pages/find-your-fit. A device that already has a scan is never
     sent to a scan screen and never starts a new scan — it is only brought to the size area. */
  function showSizeArea(btn) {
    var wrap = (btn && btn.closest('.main-wrapper-size-quicksize')) || document.getElementById('jk-sz-recommended') ||
               document.getElementById('jokers-sgb') || btn;
    if (wrap) { try { wrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
  }
  function goScanPage(it) {
    try {
      sessionStorage.removeItem('jk_scan_return');
      var fit = /women|ladies/i.test((it && it.product_type) || '') ? 'women' : 'men';
      localStorage.setItem('jk_scan_page_fit', fit);
    } catch (e) {}
    location.href = '/pages/find-your-fit#jk-fyf-scan';
  }
  function startScan(it) {
    if (it && !onThisProduct(it)) { location.href = scanUrl(it); return; }   // its #jk-scan arrival never re-scans a scanned device
    closeDrawer();
    if (hasScan()) {   // 181026: already scanned → just show the size area on this page
      setTimeout(function () { showSizeArea(document.getElementById('generateBtn')); }, 350);
      return;
    }
    var n = 0;
    (function tryIt() {
      var btn = document.getElementById('generateBtn');
      if (hasScan()) { showSizeArea(btn); return; }
      if (!btn || btn.disabled) {
        if (++n < 16) { setTimeout(tryIt, 250); return; }
        if (btn) showSizeArea(btn); else goScanPage(it);   // no size tool on this page at all → the scan page
        return;
      }
      showSizeArea(btn);
      setTimeout(function () { if (!hasScan()) btn.click(); }, 350);
    })();
  }
  /* 181026: knowMySize() removed — its "I know my size" button was taken off the card on 13 Oct */
  /* 181026: reuses the product JSON recInfo already fetched (getProduct checks r.ok; failures aren't kept) */
  function variantFor(it, rec) {
    return getProduct(it.handle)
      .then(function (p) {
        var idx = -1;
        (p.options || []).forEach(function (o, i) { var n = typeof o === 'string' ? o : (o && o.name); if (idx < 0 && /size/i.test(n || '')) idx = i; });
        if (idx < 0) idx = 0;
        var cur = (p.variants || []).filter(function (v) { return String(v.id) === String(it.id); })[0];
        return (p.variants || []).filter(function (v) {
          if (!v.options || szKey(v.options[idx]) !== szKey(rec)) return false;
          return !cur || v.options.every(function (o, i) { return i === idx || o === cur.options[i]; });
        }).map(function (v) { return { v: v, label: v.options[idx] }; })[0] || null;
      });
  }
  /* 181026: Swap's remove of the old line — once, again after 600ms, then by its key from a fresh
     /cart.js (found by variant if the key moved). A line that's already gone counts as done. */
  function removeOld(cur) {
    function zero(key) { return post('/cart/change.js?csapp=shipcs', { id: key, quantity: 0 }); }
    return zero(cur.key).catch(function () {
      return new Promise(function (r) { setTimeout(r, 600); }).then(function () { return zero(cur.key); });
    }).catch(function () {
      return getCart().then(function (c) {
        var items = c.items || [];
        var old = items.filter(function (x) { return x.key === cur.key; })[0] ||
                  items.filter(function (x) { return String(x.id) === String(cur.id); })[0];
        if (!old) return c;   // already removed
        return zero(old.key);
      });
    });
  }
  function swap(k, rec) {
    var it = (cart && cart.items || []).filter(function (x) { return x.key === k; })[0];
    if (!it) return;
    busyLines[k] = 'swap'; busyName[k] = recLabel(it, rec); delete errors[k]; paint();
    variantFor(it, rec).then(function (f) {
      if (!f) throw new Error('unmade');
      if (!f.v.available) throw new Error('soldout:' + f.label);
      return lock(function () {
        return getCart().then(function (c) {
          var cur = (c.items || []).filter(function (x) { return x.key === k; })[0] ||
                    (c.items || []).filter(function (x) { return String(x.id) === String(it.id); })[0];
          if (!cur) throw new Error('gone');
          var props = Object.assign({}, cur.properties || {});
          props._jk_size_scan = 'recommended';
          props._jk_size_note = 'Swapped in cart ' + stampNow() + ' from ' + lineSize(cur) + ' to ' + f.label + ' (recommended size)';
          return post('/cart/add.js?csapp=shipcs', { items: [{ id: f.v.id, quantity: cur.quantity, properties: props }] })
            .then(function () { return removeOld(cur); });   // 181026: retried so two costumes aren't left
        });
      });
    }).then(function () {
      busyLines[k] = 'done'; paint();   // 181026: "✓ Swapped to X — updating your cart…" until the old line goes
      setTimeout(function () { if (busyLines[k] === 'done') { delete busyLines[k]; paint(); } }, 10000);
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: {} }));
      schedule(300, true);
    }).catch(function (e) {
      delete busyLines[k];
      var m = String(e && e.message || '');
      errors[k] = m.indexOf('soldout:') === 0 ? shortSize(m.slice(8)) + ' is sold out in this costume.'
                : m === 'unmade' ? 'This costume doesn’t come in ' + recLabel(it, rec) + '.'
                : 'Sorry, we couldn’t swap the size — please change it on the product page.';
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: {} }));
      schedule(300, true);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-jk-sc]');
    if (!b || !drawer || !drawer.contains(b)) return;
    if (b.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) return;   // new tab: let the link work
    e.preventDefault();
    e.stopPropagation();
    var card = b.closest('.jk-sc'), k = card && card.getAttribute('data-jk-key');
    if (!k || busyLines[k]) return;
    var act = b.getAttribute('data-jk-sc');
    var it = (cart && cart.items || []).filter(function (x) { return x.key === k; })[0];
    if (act === 'scan') startScan(it);
    else if (act === 'swap') swap(k, b.getAttribute('data-rec'));
  }, true);

  /* 181026: the theme's <cart-drawer> carries [open] while it's showing */
  function drawerOpen() { return !!drawer && (drawer.hasAttribute('open') || drawer.open === true); }
  function bootDrawer() {
    drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    /* Our own card writes are ignored (only line-list changes matter), so this can't loop. */
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.nodeType === 1 && (t.classList.contains('jk-sc') || (t.closest && t.closest('.jk-sc')))) continue;
        var nodes = [].slice.call(muts[i].addedNodes).concat([].slice.call(muts[i].removedNodes));
        if (nodes.length && nodes.every(function (n) { return n.nodeType === 1 && n.classList && n.classList.contains('jk-sc'); })) continue;
        if (cart) paint();   // 121026 k: re-add cards the moment the drawer re-renders (181026: once per frame)
        schedule(250);
        return;
      }
    }).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('cart:refresh', function () { schedule(600, true); });
    document.addEventListener('cart:updated', function () { schedule(400, true); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(300, true); });
    /* a scan done in another tab / on the scan page, then back here */
    window.addEventListener('storage', function (e) { if (e.key && (e.key === 'ms_access_code2' || e.key.indexOf('jk_ms:') === 0)) schedule(200); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(200, true); });
    /* safety net: re-check every 2s (no network unless the cart lines changed; no DOM writes if
       the cards are already right). 181026: only while the tab is visible AND the drawer is open —
       other ticks are skipped; opening the drawer triggers a re-check straight away. */
    setInterval(function () { if (!document.hidden && drawerOpen()) refresh(false); }, 2000);
    try {
      new MutationObserver(function () { if (drawerOpen()) schedule(100); })
        .observe(drawer, { attributes: true, attributeFilter: ['open'] });
    } catch (e) {}
    schedule(50, true);
  }

  /* =====================================================================
     PRODUCT PAGE — reminder under Add to cart when the selected size isn't the
     recommended one (reads sizer-block's amber card; changes nothing in it)
     ===================================================================== */
  /* 111026: arrived from the drawer's "using our scan tool" link → bring the scan up */
  function scanOnArrival() {
    if (location.hash !== '#jk-scan') return;
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
    var n = 0;
    (function tryIt() {
      var btn = document.getElementById('generateBtn');
      if (!btn || btn.disabled) { if (++n < 40) setTimeout(tryIt, 250); return; }
      var wrap = btn.closest('.main-wrapper-size-quicksize') || document.getElementById('jokers-sgb') || btn;
      try { wrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      if (!hasScan()) setTimeout(function () { btn.click(); }, 450);
    })();
  }
  function bootPdp() {
    scanOnArrival();
    var rec = document.getElementById('jk-sz-recommended');
    if (!rec) return;
    var note = null;
    function submit() { return document.querySelector('.product-form__submit'); }
    function anchor(btn) {
      /* the row holding quantity + Add to cart (stop at the form) */
      var el = btn.parentElement, form = btn.closest('form');
      while (el && el !== form && el !== document.body) {
        if (el.querySelector('input[name="quantity"], quantity-selector, .quantity')) return el;
        el = el.parentElement;
      }
      return btn.parentElement;
    }
    function txt(sel) { var e = rec.querySelector(sel); return e ? e.textContent.trim() : ''; }
    function sync() {
      var off = rec.classList.contains('jk-sz--off') && rec.classList.contains('is-active');
      var btn = submit();
      if (!btn) return;
      if (!note) {
        note = document.createElement('p');
        note.className = 'jk-atc-note';
        note.hidden = true;
        note.innerHTML = '<button type="button" data-jk-atc-switch></button><span data-n></span>';   // 181026: button leads
        note.querySelector('[data-jk-atc-switch]').addEventListener('click', function () {
          var sw = rec.querySelector('[data-jk-switch]');
          if (sw) sw.click();
        });
      }
      var a = anchor(btn);
      if (note.previousElementSibling !== a && a.parentNode) a.parentNode.insertBefore(note, a.nextSibling);
      if (!off) { if (!note.hidden) note.hidden = true; return; }
      /* 181026: positive wording — "Switch to X-Large to get the Size Fit Guarantee." */
      var r = txt('.jk-sz__card-links [data-jk-rec]') || txt('[data-jk-rec]');
      var s = r ? 'Switch to ' + r : '';
      var n = r ? ' to get the Size Fit Guarantee.' : 'Choose your recommended size to get the Size Fit Guarantee.';
      var ns = note.querySelector('[data-n]'), sb = note.querySelector('[data-jk-atc-switch]');
      if (ns.textContent !== n) ns.textContent = n;
      if (sb.textContent !== s) sb.textContent = s;
      sb.hidden = !s;
      if (note.hidden) note.hidden = false;
    }
    var t = null;
    function later() { clearTimeout(t); t = setTimeout(sync, 60); }
    try {
      new MutationObserver(later).observe(rec, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true, characterData: true });
    } catch (e) {}
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker')) later(); }, true);
    later();
  }

  var booted = false;
  function boot() { if (booted) return; booted = true; bootDrawer(); bootPdp(); }
  /* After load (ShipZip has booted by then) — or 2.5s after the DOM is ready if 'load' is held up
     by a slow third-party script. */
  if (document.readyState === 'complete') boot();
  else {
    window.addEventListener('load', boot);
    var dcl = function () { setTimeout(boot, 2500); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dcl); else dcl();
  }
  window.__jkSizeCardVersion = '181026';   // 181026
})();
